/*
 * AUTOGENERATED - DON'T EDIT
 * Your edits in this file will be overwritten in the next build!
 * Modify the docusaurus.config.js file at your site's root instead.
 */
export default {
  "title": "ImageJS",
  "tagline": "Advanced image processing in JavaScript.",
  "favicon": "img/image-js-favicon.svg",
  "url": "https://docs.image-js.org",
  "baseUrl": "/",
  "plugins": [
    null,
    [
      "@dipakparmar/docusaurus-plugin-umami",
      {
        "websiteID": "40a43007-421b-4e66-bd35-b333727a09d3",
        "analyticsDomain": "umami.zakodium.com",
        "dataDomains": "docs.image-js.org"
      }
    ]
  ],
  "onBrokenLinks": "throw",
  "onBrokenMarkdownLinks": "warn",
  "i18n": {
    "defaultLocale": "en",
    "locales": [
      "en"
    ],
    "path": "i18n",
    "localeConfigs": {}
  },
  "presets": [
    [
      "classic",
      {
        "docs": {
          "sidebarPath": "/opt/buildhome/repo/sidebars.js",
          "editUrl": "https://github.com/image-js/image-js-docs/tree/main/",
          "remarkPlugins": [
            null
          ],
          "rehypePlugins": [
            null
          ]
        },
        "blog": {
          "showReadingTime": true,
          "blogTitle": "Docusaurus blog!",
          "blogDescription": "A Docusaurus powered blog!",
          "blogSidebarTitle": "All posts",
          "blogSidebarCount": "ALL",
          "editUrl": "https://github.com/image-js/image-js-docs/tree/main/"
        },
        "theme": {
          "customCss": "/opt/buildhome/repo/src/css/custom.css"
        }
      }
    ]
  ],
  "stylesheets": [
    {
      "href": "https://cdn.jsdelivr.net/npm/katex@0.13.24/dist/katex.min.css",
      "type": "text/css",
      "integrity": "sha384-odtC+0UGzzFL/6PNoE8rX/SPcQDXBJ+uRepguP4QkPCm2LBxH3FA3y+fKSiJ+AmM",
      "crossorigin": "anonymous"
    }
  ],
  "themeConfig": {
    "image": "/img/image-js-social-card.png",
    "metadata": [
      {
        "property": "og:image:width",
        "content": "1200"
      },
      {
        "property": "og:image:height",
        "content": "630"
      },
      {
        "name": "twitter:image:width",
        "content": "1200"
      },
      {
        "name": "twitter:image:height",
        "content": "630"
      }
    ],
    "colorMode": {
      "defaultMode": "light",
      "disableSwitch": false,
      "respectPrefersColorScheme": false
    },
    "announcementBar": {
      "id": "release-1.0",
      "content": "ImageJS 1.0 has been released! <a href=\"/blog/releases/1.0\">Click here</a> to read our announcement post.",
      "textColor": "#fff",
      "backgroundColor": "#1c4ed8",
      "isCloseable": true
    },
    "navbar": {
      "title": "ImageJS",
      "logo": {
        "alt": "ImageJS",
        "src": "img/image-js-favicon.svg"
      },
      "items": [
        {
          "type": "doc",
          "docId": "getting-started",
          "position": "left",
          "label": "Docs"
        },
        {
          "to": "/blog",
          "label": "Blog",
          "position": "left"
        },
        {
          "href": "https://api.image-js.org/",
          "label": "API reference",
          "position": "left"
        }
      ],
      "hideOnScroll": false
    },
    "footer": {
      "style": "dark",
      "links": [
        {
          "title": "Docs",
          "items": [
            {
              "label": "Getting started",
              "to": "/docs/getting-started"
            },
            {
              "label": "Basics",
              "to": "/docs/basics"
            },
            {
              "label": "Features",
              "to": "/docs/features"
            }
          ]
        },
        {
          "title": "Learn",
          "items": [
            {
              "label": "Tutorials",
              "to": "/docs/tutorials"
            },
            {
              "label": "Useful tips",
              "to": "/docs/useful-tips"
            },
            {
              "label": "Glossary",
              "to": "/docs/glossary"
            }
          ]
        },
        {
          "title": "More",
          "items": [
            {
              "label": "GitHub",
              "href": "https://github.com/image-js/image-js"
            },
            {
              "label": "API reference",
              "href": "https://api.image-js.org/"
            },
            {
              "label": "Zakodium",
              "href": "https://www.zakodium.com/"
            }
          ]
        }
      ]
    },
    "prism": {
      "theme": {
        "plain": {
          "color": "#393A34",
          "backgroundColor": "#f6f8fa"
        },
        "styles": [
          {
            "types": [
              "comment",
              "prolog",
              "doctype",
              "cdata"
            ],
            "style": {
              "color": "#999988",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "namespace"
            ],
            "style": {
              "opacity": 0.7
            }
          },
          {
            "types": [
              "string",
              "attr-value"
            ],
            "style": {
              "color": "#e3116c"
            }
          },
          {
            "types": [
              "punctuation",
              "operator"
            ],
            "style": {
              "color": "#393A34"
            }
          },
          {
            "types": [
              "entity",
              "url",
              "symbol",
              "number",
              "boolean",
              "variable",
              "constant",
              "property",
              "regex",
              "inserted"
            ],
            "style": {
              "color": "#36acaa"
            }
          },
          {
            "types": [
              "atrule",
              "keyword",
              "attr-name",
              "selector"
            ],
            "style": {
              "color": "#00a4db"
            }
          },
          {
            "types": [
              "function",
              "deleted",
              "tag"
            ],
            "style": {
              "color": "#d73a49"
            }
          },
          {
            "types": [
              "function-variable"
            ],
            "style": {
              "color": "#6f42c1"
            }
          },
          {
            "types": [
              "tag",
              "selector",
              "keyword"
            ],
            "style": {
              "color": "#00009f"
            }
          }
        ]
      },
      "darkTheme": {
        "plain": {
          "color": "#F8F8F2",
          "backgroundColor": "#282A36"
        },
        "styles": [
          {
            "types": [
              "prolog",
              "constant",
              "builtin"
            ],
            "style": {
              "color": "rgb(189, 147, 249)"
            }
          },
          {
            "types": [
              "inserted",
              "function"
            ],
            "style": {
              "color": "rgb(80, 250, 123)"
            }
          },
          {
            "types": [
              "deleted"
            ],
            "style": {
              "color": "rgb(255, 85, 85)"
            }
          },
          {
            "types": [
              "changed"
            ],
            "style": {
              "color": "rgb(255, 184, 108)"
            }
          },
          {
            "types": [
              "punctuation",
              "symbol"
            ],
            "style": {
              "color": "rgb(248, 248, 242)"
            }
          },
          {
            "types": [
              "string",
              "char",
              "tag",
              "selector"
            ],
            "style": {
              "color": "rgb(255, 121, 198)"
            }
          },
          {
            "types": [
              "keyword",
              "variable"
            ],
            "style": {
              "color": "rgb(189, 147, 249)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "comment"
            ],
            "style": {
              "color": "rgb(98, 114, 164)"
            }
          },
          {
            "types": [
              "attr-name"
            ],
            "style": {
              "color": "rgb(241, 250, 140)"
            }
          }
        ]
      },
      "additionalLanguages": [],
      "magicComments": [
        {
          "className": "theme-code-block-highlighted-line",
          "line": "highlight-next-line",
          "block": {
            "start": "highlight-start",
            "end": "highlight-end"
          }
        }
      ]
    },
    "algolia": {
      "appId": "3SP7D0W5IO",
      "apiKey": "b68edce995723ba044ae5792d5ccf61c",
      "indexName": "ImageJS documentation",
      "contextualSearch": true,
      "searchParameters": {},
      "searchPagePath": "search"
    },
    "docs": {
      "versionPersistence": "localStorage",
      "sidebar": {
        "hideable": false,
        "autoCollapseCategories": false
      }
    },
    "blog": {
      "sidebar": {
        "groupByYear": true
      }
    },
    "tableOfContents": {
      "minHeadingLevel": 2,
      "maxHeadingLevel": 3
    }
  },
  "baseUrlIssueBanner": true,
  "future": {
    "v4": {
      "removeLegacyPostBuildHeadAttribute": false,
      "useCssCascadeLayers": false
    },
    "experimental_faster": {
      "swcJsLoader": false,
      "swcJsMinimizer": false,
      "swcHtmlMinimizer": false,
      "lightningCssMinimizer": false,
      "mdxCrossCompilerCache": false,
      "rspackBundler": false,
      "rspackPersistentCache": false,
      "ssgWorkerThreads": false
    },
    "experimental_storage": {
      "type": "localStorage",
      "namespace": false
    },
    "experimental_router": "browser"
  },
  "onBrokenAnchors": "warn",
  "onDuplicateRoutes": "warn",
  "staticDirectories": [
    "static"
  ],
  "customFields": {},
  "themes": [],
  "scripts": [],
  "headTags": [],
  "clientModules": [],
  "titleDelimiter": "|",
  "noIndex": false,
  "markdown": {
    "format": "mdx",
    "mermaid": false,
    "mdx1Compat": {
      "comments": true,
      "admonitions": true,
      "headingIds": true
    },
    "anchors": {
      "maintainCase": false
    }
  }
};
